import script from "./project.vue?vue&type=script&setup=true&lang=js"
export * from "./project.vue?vue&type=script&setup=true&lang=js"

import "./project.vue?vue&type=style&index=0&id=a2990350&lang=scss&scoped=true"

import exportComponent from "/Users/luoxuelin/Workspace/idea/wnzhfc/s-pages/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2990350"]])

export default __exports__